// @ts-nocheck
export const initalFormData = {
	typeId: { error: [], value: null },
	part: { error: [], value: null },
	typeExchangeRate: { error: [], value: null },
	dolarQuotation: { error: [], value: null },
	primaryValue: { error: [], value: null },
	primaryValueUS: { error: [], value: null },
	primaryIndexId: { error: [], value: null },
	dateReference: { error: [], value: null },
	risk: { error: [], value: null },
	interestType: { error: [], value: null },
	interestDateReference: { error: [], value: null },
	interestPercents: { error: [], value: null },
	penaltyPercents: { error: [], value: null },
	emailList: { error: [], value: null },
	ipList: { error: [], value: null },
	urlList: { error: [], value: null },
	imeiList: { error: [], value: null },
	accountIdList: { error: [], value: null },
	hasInterest: { error: [], value: false },
	hasPenalty: { error: [], value: false },
	hasPrimary: { error: [], value: true },
	financialCode: { erro: [], value: null },
};

export const initalFormControl = {
	hasPrimary: {
		visible: true,
	},
	financialCode: {
		visible: true,
		disabled: false,
	},
	hasInterest: {
		visible: false,
		disabled: false,
	},
	hasPenalty: {
		visible: false,
		disabled: false,
	},
	primaryValue: {
		visible: false,
		disabled: false,
		mask: 'CURRENCY_BR',
	},
	interestPercents: {
		visible: false,
		disabled: false,
	},
	dolarQuotation: {
		visible: false,
		disabled: false,
	},
	primaryValueUS: {
		visible: false,
		disabled: false,
	},
};
